import Image from 'next/image';

import { Link } from '@/core/i18n/navigation';
import { Brand as BrandType } from '@/shared/types/blocks/common';

export function BrandLogo({ brand }: { brand: BrandType }) {
  const accessibleName = brand.title || brand.logo?.alt || 'Grid Maker home';

  return (
    <Link
      href={brand.url || ''}
      target={brand.target || '_self'}
      className={`flex items-center space-x-2 ${brand.className}`}
      aria-label={accessibleName}
    >
      {brand.logo && (
        <Image
          src={brand.logo.src}
          alt={brand.title ? '' : brand.logo.alt || accessibleName}
          width={brand.logo.width || 100}
          height={brand.logo.height || 100}
          className="h-10 w-auto"
          sizes="40px"
          unoptimized
        />
      )}
      {brand.title && (
        <span className="text-lg font-medium" style={{ fontFamily: "var(--font-display), 'VT323', monospace" }}>{brand.title}</span>
      )}
    </Link>
  );
}
